import { get } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'

import { experimentActivated, experimentVariantSelected } from '../../actions'
import { ExperimentsContext } from '../../context'
import { ExperimentsEnabled } from '../../index'
import { ExperimentState } from '../../reducers/experiments'
import { Experiment as ExperimentType, GTagAction, GTagEventCategory } from '../../types'

export interface Props {
  children: (
    experiment: ExperimentType,
    selectedVariantId: string | undefined,
    objectiveComplete: () => void,
    props: {},
  ) => React.ReactNode
  dispatchExperimentActivated: (experiment: ExperimentType) => void
  dispatchExperimentVariantSelected: (experiment: ExperimentType, selectedVariantId: string) => void
  experiment: ExperimentType
  experimentState?: ExperimentState
}

// ExperimentActivator takes an experiment as a prop, activates it in Google Optimize
// and provides the selected variant and objectiveComplete callback to the render prop
class ExperimentActivator extends React.Component<Props> {
  componentDidMount() {
    const { dispatchExperimentActivated, dispatchExperimentVariantSelected, experiment, experimentState } = this.props

    const activated = get(experimentState, 'activated', false)

    // Activate the experiment if ExperimentsEnabled, there is a custom activation event for the experiment
    // and we haven't already activated it
    if (ExperimentsEnabled && activated !== true && experiment.activationEvent !== undefined) {
      window.gtag('event', 'optimize.callback', {
        callback: (variant: string) => {
          dispatchExperimentVariantSelected(experiment, variant)
          dispatchExperimentActivated(experiment)
        },
        event_category: GTagEventCategory,
        name: experiment.id,
      })

      window.gtag('event', experiment.activationEvent, {
        event_category: GTagEventCategory,
      })
    }
  }

  objectiveComplete = () => {
    const { experiment } = this.props
    experimentObjectiveComplete(experiment)
  }

  render() {
    const { children, experiment, experimentState } = this.props

    return children(experiment, get(experimentState, 'selectedVariantId'), this.objectiveComplete, this.props)
  }
}

const mapStateToProps = (state, ownProps) => ({
  experimentState: state.experiments?.[ownProps.experiment.id],
})

const mapDispatchToProps = (dispatch) => ({
  dispatchExperimentActivated: (experiment: ExperimentType) => dispatch(experimentActivated(experiment)),
  dispatchExperimentVariantSelected: (experiment: ExperimentType, selectedVariantId: string) =>
    dispatch(experimentVariantSelected(experiment, selectedVariantId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExperimentActivator)

export const experimentObjectiveComplete = (experiment: ExperimentType) => {
  if (ExperimentsEnabled && experiment.objectiveEvent !== undefined) {
    window.gtag('event', experiment.objectiveEvent, {
      event_category: GTagEventCategory,
    })
  }
}
